export const ADD_LOAN_REQUEST_REQUEST = "ADD_LOAN_REQUEST_REQUEST";
export const ADD_LOAN_REQUEST_SUCCESS = "ADD_LOAN_REQUEST_SUCCESS";
export const ADD_LOAN_REQUEST_FAILURE = "ADD_LOAN_REQUEST_FAILURE";

export const FETCH_LOAN_REQUESTS_REQUEST = "FETCH_LOAN_REQUESTS_REQUEST";
export const FETCH_LOAN_REQUESTS_SUCCESS = "FETCH_LOAN_REQUESTS_SUCCESS";
export const FETCH_LOAN_REQUESTS_FAILURE = "FETCH_LOAN_REQUESTS_FAILURE";

export const FETCH_LOAN_REQUEST_DETAILS_REQUEST =
  "FETCH_LOAN_REQUEST_DETAILS_REQUEST";
export const FETCH_LOAN_REQUEST_DETAILS_SUCCESS =
  "FETCH_LOAN_REQUEST_DETAILS_SUCCESS";
export const FETCH_LOAN_REQUEST_DETAILS_FAILURE =
  "FETCH_LOAN_REQUEST_DETAILS_FAILURE";

export const UPDATE_LOAN_REQUEST_REQUEST = "UPDATE_LOAN_REQUEST_REQUEST";
export const UPDATE_LOAN_REQUEST_SUCCESS = "UPDATE_LOAN_REQUEST_SUCCESS";
export const UPDATE_LOAN_REQUEST_FAILURE = "UPDATE_LOAN_REQUEST_FAILURE";

export const DELETE_LOAN_REQUEST_REQUEST = "DELETE_LOAN_REQUEST_REQUEST";
export const DELETE_LOAN_REQUEST_SUCCESS = "DELETE_LOAN_REQUEST_SUCCESS";
export const DELETE_LOAN_REQUEST_FAILURE = "DELETE_LOAN_REQUEST_FAILURE";

export const ADD_APPROVE_REQUEST_REQUEST = "ADD_APPROVE_REQUEST_REQUEST";
export const ADD_APPROVE_REQUEST_SUCCESS = "ADD_APPROVE_REQUEST_SUCCESS";
export const ADD_APPROVE_REQUEST_FAILURE = "ADD_APPROVE_REQUEST_FAILURE";

export const ADD_ATTEST_REQUEST_REQUEST = "ADD_ATTEST_REQUEST_REQUEST";
export const ADD_ATTEST_REQUEST_SUCCESS = "ADD_ATTEST_REQUEST_SUCCESS";
export const ADD_ATTEST_REQUEST_FAILURE = "ADD_ATTEST_REQUEST_FAILURE";

export const ADD_VERIFY_REQUEST_REQUEST = "ADD_VERIFY_REQUEST_REQUEST";
export const ADD_VERIFY_REQUEST_SUCCESS = "ADD_VERIFY_REQUEST_SUCCESS";
export const ADD_VERIFY_REQUEST_FAILURE = "ADD_VERIFY_REQUEST_FAILURE";

export const ADD_REJECT_REQUEST_REQUEST = "ADD_REJECT_REQUEST_REQUEST";
export const ADD_REJECT_REQUEST_SUCCESS = "ADD_REJECT_REQUEST_SUCCESS";
export const ADD_REJECT_REQUEST_FAILURE = "ADD_REJECT_REQUEST_FAILURE";

export const ADD_PAY_REQUEST_REQUEST = "ADD_PAY_REQUEST_REQUEST";
export const ADD_PAY_REQUEST_SUCCESS = "ADD_PAY_REQUEST_SUCCESS";
export const ADD_PAY_REQUEST_FAILURE = "ADD_PAY_REQUEST_FAILURE";

export const ADD_QUERY_REQUEST_REQUEST = "ADD_QUERY_REQUEST_REQUEST";
export const ADD_QUERY_REQUEST_SUCCESS = "ADD_QUERY_REQUEST_SUCCESS";
export const ADD_QUERY_REQUEST_FAILURE = "ADD_QUERY_REQUEST_FAILURE";

export const ADD_COMMENT_REQUEST_REQUEST = "ADD_COMMENT_REQUEST_REQUEST";
export const ADD_COMMENT_REQUEST_SUCCESS = "ADD_COMMENT_REQUEST_SUCCESS";
export const ADD_COMMENT_REQUEST_FAILURE = "ADD_COMMENT_REQUEST_FAILURE";

export const SUBMIT_LOAN_REQUEST_REQUEST = "SUBMIT_LOAN_REQUEST_REQUEST";
export const SUBMIT_LOAN_REQUEST_SUCCESS = "SUBMIT_LOAN_REQUEST_SUCCESS";
export const SUBMIT_LOAN_REQUEST_FAILURE = "SUBMIT_LOAN_REQUEST_FAILURE";

export const FETCH_LOAN_VOUCHERS_REQUEST = "FETCH_LOAN_VOUCHERS_REQUEST";
export const FETCH_LOAN_VOUCHERS_SUCCESS = "FETCH_LOAN_VOUCHERS_SUCCESS";
export const FETCH_LOAN_VOUCHERS_FAILURE = "FETCH_LOAN_VOUCHERS_FAILURE";

export const CLEAR_LOAN_REQUESTS_ERROR = "CLEAR_LOAN_REQUESTS_ERROR";
